import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMarco, RUTA_INICIO } from './MarcoContext';

/* Atajos que funcionan en cualquier pantalla, incluso escribiendo en un campo:
     Ctrl+K        Ir a… (buscar pantalla o acción)
     Ctrl+B        contraer / expandir el menú lateral
     Alt+M         buscar en el menú lateral
     Alt+0         Inicio
     Alt+1 … 9     favoritos (la estrella en el menú o en la barra superior)
     Ctrl+D        agregar / quitar la pantalla actual de favoritos
   Los atajos de cada pantalla (Guardar, Nuevo, filas de tablas…) están en src/tema/teclado.js. */

export default function AtajosGlobales() {
  const navigate = useNavigate();
  const { abrirPaleta, paletaAbierta, cerrarPaleta, alternarMenu, opcionesFavoritas, opcionActual, alternarFavorito } = useMarco();

  useEffect(() => {
    const alTeclear = (e) => {
      if (e.defaultPrevented || e.isComposing) return;
      const tecla = (e.key || '').toLowerCase();
      const ctrl = e.ctrlKey || e.metaKey;
      // con una ventana (modal) abierta, solo Ctrl+K
      const hayModal = !!document.querySelector('.modal.show');

      if (ctrl && !e.altKey && !e.shiftKey && tecla === 'k') {
        e.preventDefault();
        if (paletaAbierta) cerrarPaleta(); else abrirPaleta();
        return;
      }
      if (paletaAbierta || hayModal) return;

      if (ctrl && !e.altKey && !e.shiftKey && tecla === 'b') { e.preventDefault(); alternarMenu(); return; }
      if (ctrl && !e.altKey && !e.shiftKey && tecla === 'd') {
        if (opcionActual) { e.preventDefault(); alternarFavorito(opcionActual.ruta); }
        return;
      }
      if (e.altKey && !ctrl && !e.shiftKey) {
        if (tecla === 'm') { e.preventDefault(); window.dispatchEvent(new Event('sym:enfocar-menu')); return; }
        // e.code para que funcione igual en teclados con distribución distinta
        const m = /^(?:Digit|Numpad)(\d)$/.exec(e.code || '');
        const n = m ? Number(m[1]) : (/^\d$/.test(e.key) ? Number(e.key) : null);
        if (n === 0) { e.preventDefault(); navigate(RUTA_INICIO); return; }
        if (n && opcionesFavoritas[n - 1]) { e.preventDefault(); navigate(opcionesFavoritas[n - 1].ruta); }
      }
    };
    document.addEventListener('keydown', alTeclear);
    return () => document.removeEventListener('keydown', alTeclear);
  }, [navigate, abrirPaleta, paletaAbierta, cerrarPaleta, alternarMenu, opcionesFavoritas, opcionActual, alternarFavorito]);

  return null;
}
